import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { ReporteService } from 'src/app/services/reportes/reporte.service';
import Swal from 'sweetalert2';
import { GenerateReportProfibilityComponent } from '../profibility-report/generate-report/generate-report.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-profibility-report',
  templateUrl: './profibility-report.component.html',
  styleUrls: ['./profibility-report.component.scss']
})
export class ProfibilityReportComponent implements OnInit {

  public settings = {
    actions: {
      columnTitle: 'Acciones',
      add: false,
      edit: true,
      delete: true,
      position: 'right'
    },
    pager: {
      display: true,
      perPage: 20,
    },
    add: {
      addButtonContent: "<span>Generar reporte</span>",
    },
    edit: {
      editButtonContent: '<span>Ver detalles</span>',
    },
    delete: {
      deleteButtonContent: '<span>Eliminar</span>',
    },
    columns: {
      report: {
        title: 'Reporte',
        filter: false
      },
      date: {
        title: 'Fecha de creación',
        filter: false
      },
    },
    mode: 'external',
    noDataMessage: 'No hay reportes por ahora'
  };
  public data_source = [];

  constructor(
    private reportService: ReporteService,
    private router: Router,
    private dialogService: MatDialog
  ) { }

  ngOnInit() {
    this.getInitialData()
  }

  async getInitialData() {
    this.data_source = await this.getReportsData()
  }

  openDetails(data) {
    var reportID = data.data._id;
    this.router.navigate(['/report-profibility-details/' + reportID])
  }
  createNew() {
    this.dialogService.open(GenerateReportProfibilityComponent, { height: '50vh' });
  }

  async getReportsData() {
    try {
      var response = await this.reportService.getProfibilityClientReport()
      response.data.map((clientReport) => {
        clientReport.date = new Date(clientReport.date).toLocaleDateString()
      })
      return response.data
    } catch (error) {
      await Swal.fire({
        title: 'Ocurrrió un error inesperado',
        icon: 'error',
        text: "Si el problema persiste, favor de reportar el error",
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      })
    }
  }

  async delete(data) {
    var reportID = data.data._id;
    var result = await Swal.fire({
      title: '¿Seguro que desea eliminar el reporte?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar'
    })
    if (result.isConfirmed) {
      try {
        this.reportService.deleteClientReport(reportID);
        await Swal.fire({
          title: 'Eliminado!',
          text: 'El reporte ha sido borrado.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false
        }
        )
        this.getInitialData()
      } catch (error) {
        await Swal.fire({
          title: 'Ocurrrió un error inesperado',
          icon: 'error',
          text: "Si el problema persiste, favor de reportar el error",
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Aceptar'
        })
      }
    }
  }

}
